import { useState, useCallback } from "react";
import { useMutation } from "@apollo/client";
import { CREATE_TRANSACTION } from "../graphql/mutations";
import { createTransactionDTO } from "../dto/TransactionDTO";

const useTransactionForm = () => {
    const [transaction, setTransaction] = useState(createTransactionDTO());
    const [showNotification, setShowNotification] = useState(false);
    const [createTransaction, { loading }] = useMutation(CREATE_TRANSACTION);

    const updateField = useCallback((field, value) => {
        setTransaction((prev) => ({ ...prev, [field]: value }));
    }, []);

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + "/upload-receipt", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Ошибка загрузки файла");
            }

            const data = await response.json();

            return data.receipt_id;
        } catch (error) {
            console.error("Ошибка загрузки файла:", error);
            return null;
        }
    };

    const submit = useCallback(async () => {
        try {
            let receiptId = null;

            // Если есть файл, загружаем его через REST API
            if (transaction.receipt?.file) {
                receiptId = await uploadFile(transaction.receipt.file);
            }
            // if (!receiptId) {
            //     throw new Error("Ошибка загрузки файла");
            // }
            console.log(transaction);
            // Создаем транзакцию
            await createTransaction({
                variables: {
                    transactionInput: {
                        projectId: transaction.project.id,
                        sum: transaction.sum,
                        datetime: transaction.datetime,
                        comment: transaction.comment,
                        description: transaction.description,
                        type: transaction.type.value,
                        receiptId: receiptId,
                        expenseCodeId: transaction.expenseCode.id,
                    }
                },
            });

            setShowNotification(true);
            setTransaction(createTransactionDTO());
        } catch (e) {
            console.error("Ошибка при создании транзакции:", e);
        }
    }, [transaction, createTransaction]);

    return { transaction, updateField, submit, showNotification, setShowNotification, loading };
};

export default useTransactionForm;
